import { render } from "./OfficeCentroCustoTab.vue?vue&type=template&id=4cb7fac5&scoped=true&ts=true"
import script from "./OfficeCentroCustoTab.vue?vue&type=script&lang=ts"
export * from "./OfficeCentroCustoTab.vue?vue&type=script&lang=ts"

import "./OfficeCentroCustoTab.vue?vue&type=style&index=0&id=4cb7fac5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb7fac5"]])

export default __exports__